export default __webpack_public_path__ + "static/media/REDE_CNT.5c00abc0.png";